<template>
  <div>
    <b-row>
      <b-col md="6">
        <validation-provider #default="{ errors }" name="client_id">
          <b-form-group label="OAuth Client ID">
            <b-form-input
              v-model="company.client_id"
              :state="errors.length ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col md="6">
        <validation-provider #default="{ errors }" name="client_secret">
          <b-form-group label="OAuth Client Secret">
            <b-form-input
              v-model="company.client_secret"
              :state="errors.length ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BMedia,
  BAvatar,
  BLink,
  BButton,
} from 'bootstrap-vue';
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BMedia,
    BAvatar,
    BLink,
    BButton,

    ValidationProvider
  },
  props: {
    company: Object
  },
  methods: {
  }
}
</script>
